import { BrowserRouter, Route, Routes } from "react-router-dom";
import SignInPage from "./adminPages/SignInPage";
import AccessDeniedPage from "./adminPages/AccessDeniedPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import Products from "./adminPages/Products";
import Users from "./adminPages/Users";
import AddProductPage from "./adminPages/AddProductPage";
import EditProductPage from "./adminPages/EditProductPage";
import EditUserPage from "./adminPages/EditUserPage";
import ManageOrders from "./adminPages/ManageOrders";
import InventoryPage from "./adminPages/InventoryPage";
import InnerInventoryPage from "./adminPages/InnerInventoryPage";
import ThankyouPage from "./adminPages/ThankyouPage";
import EmailTemplatesPage from "./adminPages/EmailTemplatesPage";
import FreeTapeListPage from "./adminPages/FreeTapeListPage";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {


  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <Routes>

        {/* Public Routes */}
        <Route path='/' element={<ProtectedRoute element={SignInPage} publicOnly />} />
        <Route path='/access-denied' element={<AccessDeniedPage />} />

        {/* Admin Protected Routes */}
        <Route path='/users' element={<ProtectedRoute element={Users} allowedRole="admin" />} />
        <Route path='/products' element={<ProtectedRoute element={Products} allowedRole="admin" />} />
        <Route path='/add-product' element={<ProtectedRoute element={AddProductPage} allowedRole="admin" />} />
        <Route path='/edit-product/:id' element={<ProtectedRoute element={EditProductPage} allowedRole="admin" />} />
        <Route path='/edit-user/:id' element={<ProtectedRoute element={EditUserPage} allowedRole="admin" />} />
        <Route path='/manage-orders' element={<ProtectedRoute element={ManageOrders} allowedRole="admin" />} />
        <Route path='/manage-inventory' element={<ProtectedRoute element={InventoryPage} allowedRole="admin" />} />
        <Route path='/email-templates' element={<ProtectedRoute element={EmailTemplatesPage} allowedRole="admin" />} />
        <Route path='/free-tapes' element={<ProtectedRoute element={FreeTapeListPage} allowedRole="admin" />} />
        <Route path='/manage-inner-inventory/:id' element={<ProtectedRoute element={InnerInventoryPage} allowedRole="admin" />} />
        <Route path='/order/:id' element={<ProtectedRoute element={ThankyouPage} allowedRole="admin" />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
